<template>
  <div class="img-z" :style="{ width, height }">
    <div :style="{ width, height }" class="box">
      <div class="content">
        <img
          :style="{ width, height }"
          v-if="fileType === 'image'"
          :src="src" />
        <video
          :style="{ width, height }"
          v-if="fileType === 'video'"
          class="video"
          ref="videoPlayer"
          :controls="false"
          :src="src">
          浏览器不支持播放视频
        </video>
      </div>
      <div class="mask">
        <i v-if="showDetele" @click="$emit('deleteFile')" class="el-icon-delete icon"></i>
        <i @click="showMaster = true" class="el-icon-zoom-in icon"></i>
      </div>
    </div>
    <div v-show="showMaster" class="viewer-wrapper">
      <div class="viewer-mask"></div>
      <span @click="showMaster = false" class="viewer__btn viewer__close">
        <i class="el-icon-close"></i>
      </span>
      <div class="viewer-canvas">
        <img
          v-if="fileType === 'image'"
          :src="src"
          class="img-p el-image-viewer__img" />
        <video
          v-if="fileType === 'video'"
          controls
          :src="src"
          class="img-p el-image-viewer__img">
          浏览器不支持播放视频
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageZ',
  data() {
    return {
      showMaster: false,
      thumbnailSrc: null,
      showMask: false
    }
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '80px'
    },
    height: {
      type: String,
      default: '80px'
    },
    showDetele:{
      type: Boolean,
      default: true
    }
  },
  computed: {
    fileType: function () {
      return this.getFileType(this.src)
    }
  },
  methods: {
    getFileType(url) {
      const imageExtensions = /\.(jpeg|jpg|png|gif|bmp|svg|webp)$/i
      const videoExtensions = /\.(mp4|mov|wmv|avi|mkv|flv|webm|m4v|3gp)$/i

      if (imageExtensions.test(url)) {
        return 'image'
      } else if (videoExtensions.test(url)) {
        return 'video'
      } else {
        return 'unknown'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.video {
  cursor: pointer;
}
.icon {
  color: white;
  font-size: 20px;
  cursor: pointer;
}
.box {
  position: relative;
  overflow: hidden;
}

.content {
  width: 100%;
  height: 100%;
}

.mask {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 蒙版颜色和透明度 */
  opacity: 0;
  transition: all 0.3s;
}

.box:hover .mask {
  opacity: 1;
}
.img-p {
  object-fit: cover;
  height: 100%;
  width: auto;
  position: relative;
  z-index: 3000;
}
.img-z {
  overflow: hidden;
  width: 80px;
  height: 80px;
}
img {
  cursor: pointer;
}
.viewer-canvas {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.viewer-actions-inner {
  width: 100%;
  height: 100%;
  text-align: justify;
  cursor: default;
  font-size: 23px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.viewer-actions {
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  width: 282px;
  height: 44px;
  padding: 0 23px;
  background-color: #606266;
  border-color: #fff;
  border-radius: 22px !important;
}
.viewer__btn {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.8;
  cursor: pointer;
  box-sizing: border-box;
  user-select: none;
}
.viewer__close {
  top: 40px;
  right: 40px;
  width: 40px;
  height: 40px;
  font-size: 24px;
  color: #fff;
  background-color: #606266;
}
.viewer-wrapper {
  z-index: 2027;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .viewer-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.5;
    background: #000;
  }
}
</style>
